import {Component, OnInit} from '@angular/core';
import {Translations} from '../../services/translations.service';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ToastService} from '../../services/toast.service';
import {SessionStorageService} from '../../services/session-storage.service';
import {Router} from '@angular/router';
import {RoutingConstants} from '../../models/routing/routing-constants';
import {RestApiError} from '../../services/api/rest-api-error';
import {RestApiService} from '../../services/api/rest-api.service';
import {FormsModule} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {NgIf} from '@angular/common';
import {Button, ButtonDirective} from 'primeng/button';
import {Ripple} from 'primeng/ripple';

@Component({
  standalone: true,
  selector: 'app-recover-password',
  templateUrl: './request-recovery-password.component.html',
  styleUrls: ['./request-recovery-password.component.scss'],
  imports: [TranslatePipe,
    FormsModule,
    InputText,
    NgIf,
    ButtonDirective,
    Ripple],
})
export class RequestRecoveryPasswordComponent implements OnInit {

  RoutingConstants = RoutingConstants;
  loading = false;
  sentEmail = false;
  email: string = '';

  constructor(public translations: Translations,
              private translateService: TranslateService,
              private api: RestApiService,
              private toastService: ToastService,
              private storage: SessionStorageService,
              private router: Router) {
  }

  ngOnInit(): void {
  }

  async recoverPassword() {
    if (!this.email) {
      this.toastService.error(
        this.translateService.instant(this.translations.commons.error),
        this.translateService.instant(this.translations.commons.compileAllFields)
      );
      return;
    }

    try {
      this.loading = true;
      const response = await this.api.users.recoveryPassword({email: this.email});
      this.toastService.success(
        this.translateService.instant(this.translations.auth.recoverPassword),
        this.translateService.instant(this.translations.auth.emailSentCheckInbox)
      );
      this.sentEmail = true;
    } catch (e) {
      if (e instanceof RestApiError) {
        this.toastService.error(
          this.translateService.instant(this.translations.auth.recoverPassword),
          e.response.toString());
        console.log({r: e.response});
      }
    } finally {
      this.loading = false;
    }
  }
}
